import { z } from "zod";
import { CONTACT_NAME_MAX, NOTES_MAX } from "@shared/constants/validation.js";

const INSURANCE_FIELD_MAX = 120;
const HOSPITAL_MAX = 200;

const nullableTrimmedString = (max: number) =>
  z
    .string()
    .trim()
    .max(max)
    .nullish()
    .transform((v) => (v && v.length > 0 ? v : null));

/**
 * Upsert payload for the consent-to-treat record. Every field is optional so a
 * partial save never clears what it doesn't mention (same contract as the
 * feeding and medical-history upserts).
 *
 * `consentGrantedAt` is NOT accepted from the client: the server stamps it when
 * consent flips on, so the record reflects when consent was actually given
 * rather than whatever timestamp a caller chose to send. See
 * CareAuthorizationsService.save.
 */
export const upsertCareAuthorizationSchema = z.object({
  consentToTreat: z.boolean().optional(),
  consentGrantedByName: nullableTrimmedString(CONTACT_NAME_MAX),
  insuranceCarrier: nullableTrimmedString(INSURANCE_FIELD_MAX),
  insurancePolicyNumber: nullableTrimmedString(INSURANCE_FIELD_MAX),
  insuranceGroupNumber: nullableTrimmedString(INSURANCE_FIELD_MAX),
  preferredHospital: nullableTrimmedString(HOSPITAL_MAX),
  notes: nullableTrimmedString(NOTES_MAX),
});

export type UpsertCareAuthorizationInput = z.infer<typeof upsertCareAuthorizationSchema>;
